<script setup lang="ts">
import type { ICommodity, ICrypto, IFinancialAsset, IRealEstate, IStock, TAssetType } from '~/@types/assets'
import { formatCurrency } from '@helpers/numberHelper'
import { useAssetsWatchingStore } from '~/stores/assetsWatching'

const props = defineProps({
  asset: null
})

const emit = defineEmits(["asset-click"])
// 👇 emit setup
interface Emits {
  'asset-click': [id: string]
}
function handleArticleClick() {
  emit('asset-click', props.asset.id)
}

// (optional) keyboard support
function handleArticleKey(e: KeyboardEvent) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault()
    emit('asset-click', props.asset.id)
  }
}

const assetWatchStore = useAssetsWatchingStore()
const isWatching = ref(true)
const type: TAssetType = props.asset.type
const title = props.asset.type === 'real_estate' ? props.asset.address : (props.asset.type === 'financial_asset' ? (props.asset.description ?? 'Financial asset') : props.asset.symbol)
const subtitle = props.asset.type === 'real_estate' ? 'Real Estate' : (props.asset.type === 'financial_asset' ? props.asset.financial_asset_type : props.asset.name)

function isWatchingChanged(value: boolean): void {
  if (!props.asset)
    return
  value ? assetWatchStore.watchAsset(props.asset.id) : assetWatchStore.unwatchAsset(props.asset.id)
}
</script>

<template>
  <article
    class="asset-item bg-black border border-gray-800 rounded-xl hover:border-gray-700 transition-all duration-200 cursor-pointer"
    tabindex="0"
    role="button"
    @click="handleArticleClick"
    @keydown="handleArticleKey"
  >
    <div class="px-4 py-2">
      <div class="flex items-start justify-between mb-3">
        <div>
          <div class="flex justify-start">
            <h3 class="font-semibold capitalize  text-lg mr-4">
              {{ title }}
            </h3>
            <ShariahComplianceBadge v-if="asset.type === 'stock'" :compliant="asset.is_shariah_compliant" class="mr-4" />
          </div>

          <p class="text-sm capitalize text-gray-500 mt-0.5">
            {{ subtitle }}
          </p>
        </div>
        <div>
          <span v-if="asset.type !== 'real_estate' && asset.type !== 'financial_asset'" class="text-lg">{{ formatCurrency(asset.latest_value, asset.currency) }}</span>
        </div>
      </div>
    </div>
  </article>
</template>
